<template>
    <RedesignBasePopover
        v-if="shouldShowWrapupTag"
        trigger="hover"
        :visible-arrow="false"
    >
        <template #reference>
            <RedesignTag
                :color="WRAPUP_TAG_COLOR"
                :background-color="WRAPUP_TAG_BG_COLOR"
                :tag-content="wrapupTagContent"
                :icon-size="dynamicSizes.iconSize"
                :text-size="dynamicSizes.textSize"
                :uppercase="false"
            />
        </template>
        <div class="text-sm">
            {{ $t('extension.wrapup.tooltip') }}
        </div>
    </RedesignBasePopover>
</template>

<script lang="ts" setup>
import { computed, toRef } from 'vue'
import { useWrapupCountdown, WRAPUP_TAG_COLOR, WRAPUP_TAG_BG_COLOR } from '@/composables/useWrapupCountdown'
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'
import type { Extension } from '@/types/extension'

const props = defineProps<{
    extension?: Extension
    textSize: string
}>()

const extensionRef = toRef(props, 'extension')

const { shouldShowWrapupTag, displayTime } = useWrapupCountdown(extensionRef as any)

const dynamicSizes = computed(() => ({
    textSize: props.textSize,
    iconSize: parseInt(props.textSize)
}))

const wrapupTagContent = computed(() => [
    {
        iconName: 'TimerReset',
        text: displayTime.value
    }
])
</script>
